import React, { FC } from 'react';
import Form from 'components/Form';

import { AnouslestoilettesPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Anouslestoilettes: FC<AnouslestoilettesPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Anouslestoilettes;
